import { CapacityCalculationParams } from "./type";

export function isGroupFullOfGuests({
  nodeRequirePlayerCounts,
  nodeStandardCapacity,
  nodeUsedCapacity,
  isGolfCourse,
  playersLength,
  groupSize = 1,
  bookingType,
  bookingWizardCapacity,
}: CapacityCalculationParams): boolean {
  if (bookingType === "LessonBooking") {
    return (groupSize || 1) === playersLength;
  }

  if (bookingType === "RequestBooking") {
    return bookingWizardCapacity === playersLength;
  } else if (!nodeRequirePlayerCounts || isGolfCourse) {
    const usedCapacity = nodeUsedCapacity ?? 0;
    return (nodeStandardCapacity || 0) - usedCapacity === playersLength;
  }
  return playersLength === (groupSize || 1);
}
